import React, {Component} from 'react'
import { connect } from 'react-redux'

// import styles
import './Workhours.scss'

// Actions
import { GetWorkHourLogs } from '../../../actions/employees'

// import components
import Modal from '../../components/Modal'
import WorkHours from '../../components/Workhours'

// Elements
import Grid from '../../elements/grid'
import SideMenu from '../../elements/sideMenu'
import SideMenuItem from '../../elements/sideMenuItem'

import { ModalIcons } from '../../elements/icons'

// Utils
import { renderFullDate } from '../../../utils/time'
import { translation } from '../../../utils/helpers'

class WorkhoursModal extends Component {

  constructor (props) {
    super(props)
    this.state = {
      Log: [],
      SelectedIndex: 0,
      openMenu: false,
      bottomBarProps: null
    }

    this.renderLog = this.renderLog.bind(this)
    this.renderEddit = this.renderEddit.bind(this)
    this.updateLogs = this.updateLogs.bind(this)
    this.triggerMenu = this.triggerMenu.bind(this)
    this.setBottomBarProps = this.setBottomBarProps.bind(this)
  }

  componentDidMount () {
    this.props.GetWorkHourLogs(this.props.UserId).then((res) => {
      this.setState({
        Log: res.data,
        SelectedIndex: res.data.length - 1
      })
    })
  }

  setBottomBarProps (bottomBarProps) {
    this.setState({ bottomBarProps: bottomBarProps })
  }

  triggerMenu () {
    if (!this.state.openMenu) {
      document.addEventListener('click', this.triggerMenu, true)
    } else {
      document.removeEventListener('click', this.triggerMenu, true)
    }

    this.setState({
      openMenu: !this.state.openMenu
    })
  }

  updateLogs (data) {
    this.props.SetWorkHours(data[data.length - 1])
    this.props.onClose()
  }

  renderLog () {
    const setSelectedIndex = (index) => {
      this.setState({
        SelectedIndex: index
      })
    }

    const renderLogItem = (val, key) => {
      // let classes = this.state.SelectedIndex === key ? 'selected' : ''

      return (
        <SideMenuItem
          label={renderFullDate(val.Date, false)}
          onClick={setSelectedIndex.bind(this, key)}
          selected={key === this.state.SelectedIndex}
          key={key}
        />
      )
    }

    return (
      <div className='workhour'>
        <Grid cols={[ 'max-content' ]}>
          <SideMenu disableFilter>
            {this.state.Log.map(renderLogItem)}
          </SideMenu>

          <WorkHours onlyShow WorkHours={this.state.Log[this.state.SelectedIndex]} InModal IsLog displayId={2} />
        </Grid>
      </div>
    )
  }

  renderEddit () {
    if (this.state.Log[this.state.Log.length - 1] === undefined) return null
    let dates = this.state.Log.map(x => x.Date)
    return (
      <WorkHours
        updateLogs={this.updateLogs.bind(this)}
        Dates={dates}
        WorkHours={this.state.Log[this.state.Log.length - 1]}
        InModal
        onClose={this.props.onClose}
        displayId={2}
        onlyShow={false}
        setBottomBarProps={this.setBottomBarProps}
      />
    )
  }

  render () {
    let IsHistory = this.props.IsHistory
    let header = ''
    let icon = ''

    if (this.props.IsHistory) {
      header = translation('14731')
      // icon = '../svgs/log-white.svg'
      icon = ModalIcons.WorkHours_Log
    } else {
      header = translation('14730')
      icon = undefined
    }

    return (
      <div className={'Workhours__modal' + (IsHistory ? ' IsLog' : '')}>
        <Modal {...this.props}
          show
          header={header}
          icon={icon}
          onClose={this.props.onClose}
          bottomBarProps={this.state.bottomBarProps}
        >
          {IsHistory ? this.renderLog() : this.renderEddit()}
        </Modal>
      </div>
    )
  }
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {
  GetWorkHourLogs
})(WorkhoursModal)



// WEBPACK FOOTER //
// ./src/app/shared/modals/WorkhourModal/index.js